export class FiltrosCita {

  constructor(
      public ciudad:string,
      public programa:string,
      public tipoIdentificacion: string,
      public numeroIdentificacion: string,
      public remision: string[],
      public especialidad: string,
      public idEstadoCita: number,
      public fechaInicio: string,
      public fechaFin: string,
      public page: number,
      public size: number
  ) {

  }
}
